import React, { useContext, useState } from "react";
import AuthContext from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import { useForm, Controller } from "react-hook-form";
import { styled } from "@mui/material/styles";
import { Link as RouterLink } from "react-router-dom";

const RedSpan = styled("span")(({ theme }) => ({
  color: "red",
}));

const Login = () => {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const {
    handleSubmit,
    control,
    register,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const onSubmit = async ({ email, password }) => {
    try {
      await login(email, password);
      navigate("/");
    } catch (error) {
      setErrorMessage("Login failed. Please try again.");
    }
  };

  return (
    <section>
      <Container maxWidth="sm">
        <Box pt={8} pb={10}>
          <Box mb={6} textAlign="center">
            <Typography variant="h4" component="h2" gutterBottom>
              Log In
            </Typography>
            <Typography variant="subtitle1" color="textSecondary" paragraph>
              Sign in to your account
            </Typography>
          </Box>

          <form onSubmit={handleSubmit(onSubmit)} noValidate>
            {errorMessage && (
              <Box mb={2}>
                <Typography color="error">{errorMessage}</Typography>
              </Box>
            )}
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Controller
                  name="email"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      type="email"
                      variant="outlined"
                      required
                      fullWidth
                      onChange={onChange}
                      value={value}
                      id="email"
                      label={"Email"}
                      placeholder="Email address"
                      autoComplete="email"
                    />
                  )}
                  {...register("email", {
                    required: true,
                    pattern:
                      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                  })}
                  ref={null}
                />
                {errors.email && (
                  <RedSpan>Please enter a valid email address</RedSpan>
                )}
              </Grid>

              <Grid item xs={12}>
                <Controller
                  name="password"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      type="password"
                      variant="outlined"
                      required
                      fullWidth
                      onChange={onChange}
                      value={value}
                      id="password"
                      label={"Password"}
                      placeholder="Password"
                      autoComplete="current-password"
                    />
                  )}
                  {...register("password", { required: true })}
                  ref={null}
                />
                {errors.password && (
                  <RedSpan>Please enter a password</RedSpan>
                )}
              </Grid>
            </Grid>
            <Box mt={1} textAlign="right">
              <Link component={RouterLink} to="/forgot-password" underline="hover">
                Forgot password?
              </Link>
            </Box>
            <Box my={2}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                disabled={!isValid}
              >
                Login
              </Button>
            </Box>
          </form>
        </Box>
      </Container>
    </section>
  );
};

export default Login;
